// extracted by mini-css-extract-plugin
export var root = "m_p8";
export var wrapper = "m_p9";
export var image = "m_qb g_ch g_ck g_cH";
export var crop = "m_qc";
export var round = "m_qd";
export var fixedHeight = "m_qf";